import isPropValid from '@emotion/is-prop-valid';
import memoize from '@emotion/memoize';
var exceptions = ['color'];
export var createShouldForwardProp = function createShouldForwardProp(props) {
  var regex = new RegExp("^(".concat(props.join('|'), ")$"));
  return memoize(function (prop) {
    return isPropValid(prop) && !regex.test(prop);
  });
};
export default createShouldForwardProp(exceptions);
//# sourceMappingURL=shouldForwardProp.js.map